import React, { Component } from 'react';
import { Form as Formsy } from 'formsy-react';
import Dialog from 'material-ui/Dialog';
import { asDialog } from '../Common/Decorators';
import { LabelDialogs } from '../../constants/Dialogs';
import DialogActions from '../../actions/DialogActionCreator';
import TextField from '../Common/TextField';
import FlatButton from 'material-ui/FlatButton';
import LabelActions from "../../actions/LabelActionCreator";


class LabelFormDialog extends Component {

    componentDidMount() {
        this.onSubmit = this.onSubmit.bind(this);
    }

    render() {
        const isEdit = !!this.props.id;
        return (
            <Dialog
                title={!this.props.draft.isEdit ? "Add Label" : "Edit Label"}
                open={this.props.open === LabelDialogs.LABEL}
                modal={false}
                onRequestClose={DialogActions.close}
            >
                <Formsy onSubmit={this.onSubmit}>
                    <TextField name="name" hintText="Name" floatingLabelText="Name" value={!!this.props.draft.isEdit && this.props.draft.name}/>
                    <br /><br />
                    <div style={{textAlign: "right"}}>
                        <FlatButton key="cancel" label="Cancel" onTouchTap={DialogActions.close} />
                        <FlatButton key="submit" label={!this.props.draft.isEdit ? "Add" : "Update"} type="submit" />
                    </div>
                </Formsy>
            </Dialog>
        );
    }

    onSubmit(model) {
        if (!this.props.draft.isEdit) {
            LabelActions.addLabel(model);
        } else {
            LabelActions.updateLabel(this.props.draft.id, model);
        }
        DialogActions.close();
    }
}


export default asDialog(LabelFormDialog);
